export const streamId = {
  type: "string",
  minLength: 1,
  maxLength: 1_000
};
export const nullableStreamId = {
  ...streamId,
  type: ["null", "string"]
};
